export const layerPaint = {
  'heatmap-weight': {
    property: 'agencyCode',
    type: 'exponential',
    stops: [[0, 0], [5, 2]]
  },
  'heatmap-intensity': {
    stops: [[0, 0], [5, 1.2]]
  },
  'heatmap-color': [
    'interpolate',
    ['linear'],
    ['heatmap-density'],
    0,
    'rgba(33,102,172,0)',
    0.25,
    'rgb(180, 233, 241)',
    0.5,
    'rgb(104, 208, 222)',
    0.8,
    'rgb(123, 211, 222)',
    1,
    'rgb(106, 184, 195)',
    2,
    'rgb(37, 82, 88)'
  ],
  'heatmap-radius': {
    stops: [[0, 1], [5, 50]]
  }
};



// WEBPACK FOOTER //
// ./src/share/components/Maps/Heatmap/layerPaint.ts